var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-offcanvas__item" }, [
    _vm._m(0),
    _c("div", { staticClass: "map-offcanvas__body" }, [
      _c("div", { staticClass: "uk-text-meta" }, [
        _vm._v("※最大" + _vm._s(_vm.maxrows) + "行まで入力できます。")
      ]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.memo,
            expression: "memo"
          }
        ],
        staticClass: "uk-textarea map-offcanvas__memo",
        attrs: { rows: _vm.maxrows },
        domProps: { value: _vm.memo },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.memo = $event.target.value
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map-offcanvas__title" }, [
      _c("span", { attrs: { "uk-icon": "icon: file-text; ratio: .7" } }),
      _c("div", [_vm._v(" メモ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }